export default __webpack_public_path__ + "static/media/cartoon.631c3839.png";